<mat-nav-list>
  <div *ngFor="let sidenavItem of sidenavService.sidenavItems$ | async" class="mb-3">
    <app-sidenav-item *ngIf="sidenavItem.isEnabled" [sidenavItem]="sidenavItem" [ngClass]="sidenavItem.classes"></app-sidenav-item>
  </div>
</mat-nav-list>
